module.exports = __webpack_public_path__ + "static/media/burger-btn.226f8d4a.png";